module.exports = __webpack_public_path__ + "img/fengquanquAppImage.2ce28fc5.png";